import { ReactNode, useState } from 'react';
import { Snackbar } from '@mui/material';
import Alert from '../../Alert';

type Props = {
    warningMessage: string;
    action?: ReactNode;
    onClose?: () => void;
};

const WarningSnackbar = ({ warningMessage, action, onClose }: Props) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={10000}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <Alert
                onClose={handleClose}
                severity="warning"
                sx={{
                    '& .MuiAlert-icon': {
                        display: 'flex',
                        alignItems: 'center',
                        paddingTop: 1,
                    },
                    '& .MuiAlert-message': {
                        display: 'flex',
                        alignItems: 'center',
                    },
                    '& .MuiAlert-action': {
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: 0.5,
                        '& button': {
                            padding: 2,
                        },
                    },
                }}
                {...{ action }}
            >
                {warningMessage}
            </Alert>
        </Snackbar>
    );
};

export default WarningSnackbar;
